import React from 'react';
import { Tooltip } from '../tooltip/tooltip.js';
import classNames from 'classnames';

/**
 * A styled label
 * @param {Object} props - the label props
 * @param {React.ReactElement} [props.icon] - the icon to display in the label
 * @param {string} [props.text] - the text to display for the label
 * @param {string} [props.tooltipText] - the text for the label tooltip
 * @param {boolean} [props.required] - Whether or not you should display a * for the label
 * @param {boolean} [props.withInput] - Whether or not this label belongs to an input
 * @param {string} [props.alignment] - the label alignment
 * @param {string} [props.size] - the size of the label text
 * @returns {React.ReactElement} - a label
**/
const Label = ( { className, icon, text, tooltipText, required, withInput, alignment, size, children } ) => {
    const labelClasses = classNames( {
        'nackle-label': true,
        [ alignment ]: alignment ? true : false,
        [ className ]: className ? true : false,
        [ size ]: size ? true : false,
        'default': size ? false : true
    } );
    if ( withInput === true ) {
        return (
            <label className={ labelClasses }>
                <div className="label-content-wrapper">
                    <div className="label-text">
                        { text }
                        {
                            required &&
                            <span className="required">*</span>
                        }
                    </div>
                    {
                        tooltipText && icon &&
                        <Tooltip title={ tooltipText }>
                            <div className="label-icon with-tooltip">{ icon }</div>
                        </Tooltip>
                    }
                    {
                        !tooltipText && icon &&
                        <div className="label-icon no-tooltip">{ icon }</div>
                    }
                </div>
                { children }
            </label>
        );
    } else {
        return (
            <div className={ labelClasses }>
                <div className="label-content-wrapper">
                    <div className="label-text">
                        { text }
                        {
                            required &&
                            <span className="required">*</span>
                        }
                    </div>
                    {
                        tooltipText && icon &&
                        <Tooltip title={ tooltipText }>
                            <div className="label-icon with-tooltip">{ icon }</div>
                        </Tooltip>
                    }
                    {
                        !tooltipText && icon &&
                        <div className="label-icon no-tooltip">{ icon }</div>
                    }
                </div>
                { children }
            </div>
        );
    }
};

export { Label };
